<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 授权管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>退款确认</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.accountType" placeholder="请选择账户类型" @change="queryAccountTypeChange">
					<el-option key="" label="请选择账户类型" value=""></el-option>
					<el-option key="0" label="渠道账户" value="0"></el-option>
					<el-option key="1" label="客户账户" value="1"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.companyId" placeholder="请选择公司" filterable>
					<el-option key="" label="请选择公司" value=""></el-option>
					<el-option v-for="item in queryCompanysKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="accountType" label="账户类型" width = "100px" :formatter="accountTypeFormat"></el-table-column>
				<el-table-column prop="accountCompanyName" label="账户名称"></el-table-column>
				<el-table-column prop="operate" label="操作类型" width = "120px" :formatter="operateTypeFormat"></el-table-column>
				<el-table-column prop="balanceBefore" label="操作前余额" width = "120px"></el-table-column>
				<el-table-column prop="amount" label="申请退款金额" width = "120px"></el-table-column>
               <el-table-column prop="operateInfo" label="凭证信息" width = "160px">
					<template slot-scope="scope" v-if="scope.row.operateInfo">
						<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in scope.row.operateInfo.split(',')">
							<div style="float:left">
								<el-image
									class="table-td-thumb"
									:src="imgPrefix+payReceiptItem"
									:preview-src-list="[imgPrefix+payReceiptItem]"
								v-if="scope.row.operate==2&&scope.row.operateInfo"></el-image>
							</div>
						</el-tooltip>
                    </template>
				</el-table-column>
				<el-table-column prop="status" label="状态" :formatter="statusFormat" width = "100px"></el-table-column>
				<el-table-column prop="createTime" label="申请时间" width = "160px"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
						<el-button
                            type="text"
                            icon="el-icon-upload"
                            @click="handleUpload(scope.$index, scope.row)"
							v-if = "controll['upload'] && (scope.row.accountType==0&&scope.row.operateInfo==undefined &&scope.row.status==undefined)||(scope.row.accountType==1&&scope.row.operateInfo==undefined&&scope.row.status==0)"
                        >上传凭证</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="退款申请详情" :visible.sync="showVisible" width="40%">
			<el-form ref="refund" :model="refund" label-width="120px">
				<el-descriptions class="margin-top" title="" :column="2" size="medium" labelStyle="width:150px;" border>
					<el-descriptions-item>
						<template slot="label">
							账户类型
						</template>
						{{accountTypeFormat(null, null, refund.accountType)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							操作类型
						</template>
						{{operateTypeFormat(null, null, refund.operate)}}
					</el-descriptions-item>
					<el-descriptions-item span="2">
						<template slot="label">
							名称
						</template>
						{{refund.accountCompanyName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							操作前余额
						</template>
						￥{{refund.balanceBefore}}
					</el-descriptions-item><el-descriptions-item>
						<template slot="label">
							退款金额
						</template>
						￥{{refund.amount}}
					</el-descriptions-item>
					<el-descriptions-item span="2">
						<template slot="label">
							退款申请说明
						</template>
						{{refund.remark}}
					</el-descriptions-item>
					<el-descriptions-item  span="2" v-if="refund.operateInfo">
						<template slot="label">
							退款凭证
						</template>
						<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in refund.operateInfo.split(',')">
							<div style="float:left">
								<el-image
									class="table-td-thumb"
									:src="imgPrefix+payReceiptItem"
									:preview-src-list="[imgPrefix+payReceiptItem]"
								v-if="refund.operate==2&&refund.operateInfo"></el-image>
							</div>
						</el-tooltip>
					</el-descriptions-item>
					<el-descriptions-item span="2">
						<template slot="label">
							状态
						</template>
						{{statusFormat(refund, null, refund.status)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							审核人
						</template>
						{{refund.reviewerName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							审核时间
						</template>
						{{refund.reviewerTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							确认人
						</template>
						{{refund.withdrawConfirmName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							确认时间
						</template>
						{{refund.withdrawConfirmTime}}
					</el-descriptions-item>
					<el-descriptions-item span="2">
						<template slot="label">
							确认备注
						</template>
						{{refund.withdrawConfirmRemark}}
					</el-descriptions-item>
				</el-descriptions>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showVisible = false">关 闭</el-button>
			</span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="退款凭证" :visible.sync="refundVisible" width="40%">
			<el-form ref="refund" :model="refund" label-width="120px" :rules="refundRules">
				<el-form-item label="名称：" prop="accountCompanyName">
					{{refund.accountCompanyName}}
				</el-form-item>
				<el-form-item label="操作前余额：" prop="balanceBefore">
					￥{{refund.balanceBefore}}
				</el-form-item>
				<el-form-item label="退款金额：" prop="amount">
					￥{{refund.amount}}
				</el-form-item>
				<el-form-item label="退款凭证" prop="operateInfo">
					<el-upload
						class="upload-demo"
						multiple = false
						:before-upload="beforeUpload"
						:action= "uploadUrl"
						:on-success="uploadSuccess"
						:on-remove="handleRemove"
						:file-list="paidFileList"
						accept=".png,.jpg"
						list-type="picture">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="备注：" prop="withdrawConfirmRemark">
					<el-input type=textarea :rows=5 v-model="refund.withdrawConfirmRemark"> </el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="refundVisible = false">取 消</el-button>
				<el-button type="primary" @click="uploadPaidInfo" v-prevent-re-click>提交</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchRefundAccountRecordPages, passAccountRecord, refuseAccountRecord, getAllCustomerKV, getChannelKV, getAccountRecord, updateAccountPaidInfo } from '../../../api/index';
export default {
    name: 'refund-paid-confirm',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
			pageTotal: 0,
            tableData: [],
			queryCompanysKV:[],
			showVisible:false,
			refund:{},
			imgPrefix:"/image",
			uploadUrl : "/image/upload/16",
			paidFileList:[],
			refundVisible:false,
			refundRules:{
				operateInfo: [{ required: true, message: '退款凭证不能为空！', trigger: 'blur' }]
			},
			controll:{}
			
        };
		
    },
    created() {
		this.controll = getControll("refund-paid-confirm");
		let ckey = localStorage.getItem('ms_ckey');
		this.uploadUrl = "/image/upload/" + ckey + "/16";
        this.getData();
    },
    methods: {	
		operateTypeFormat(row, column, cellValue) {
			let operateTypeConfig = {"0":"撤单", "1":"订货", "2":"退款"};
			return operateTypeConfig[cellValue];
		},
		accountTypeFormat(row, column, cellValue) {
			let arrivalStatusConfig = {"0":"渠道账户", "1":"客户账户"};
			return arrivalStatusConfig[cellValue];
		},
		queryAccountTypeChange(value) {
			if(value == "" || value == undefined) {
				this.queryCompanysKV = [];
				return;
			}
			let execQuery = value === "0"?getChannelKV:getAllCustomerKV;
			execQuery().then(res => { 
				if (res.code == 0 ) {
					this.queryCompanysKV = res.data;
				} else {
					this.$message.error("获取公司信息失败");
				}
            });
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchRefundAccountRecordPages(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 提交凭证
        handleUpload(index, row) {
			this.paidFileList = [];
			getAccountRecord(row.id).then(res=>{
				if (res.code == 0 ) {
					this.refund = res.data;
					this.refundVisible = true;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			})
        },
		handleShow(index, row) {
			getAccountRecord(row.id).then(res => {
				if (res.code == 0) {
					this.refund = res.data;
					this.showVisible = true;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		statusFormat(row, column, cellValue) {
			let status;
			let operateTypeConfig
			if (row.accountType==0) {
				status = "确认中...";
				operateTypeConfig = {"0":"已确认", "1":"已撤销"};
			} else {
				status = "处理中...";
				operateTypeConfig = {"0":"通过", "1":"拒绝"};
			}
			return operateTypeConfig[cellValue]==undefined?status:operateTypeConfig[cellValue];
		},
		//文件上传
		uploadSuccess(response, file, fileList) {
			this.refund.operateInfo = response.data;
		},
		//删除图片
		handleRemove(file, fileList) {
			let fileName = file.response.data;
			removeImg([fileName]).then(res => {
				if (res.code == 0 ) {
					let files = this.paid.payReceipt.split(",");
					let index = files.findIndex(item => {
						if (item === fileName) {
							return true;
						}
					});
					files.splice(index,1);
					this.paid.payReceipt = files.join(",");
					this.$message.success("删除图片成功");
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		uploadPaidInfo() {
			this.$refs.refund.validate(valid => {
				let data = {};
				data["id"] = this.refund.id;
				data["operateInfo"] = this.refund.operateInfo;
				data["withdrawConfirmRemark"] = this.refund.withdrawConfirmRemark;
				updateAccountPaidInfo(data).then(res => {
					if (res.code == 0 ) {
						this.refundVisible = false;
						this.$message.success("上传凭证成功");
						this.getData();
					} else {
						this.$message.error("上传凭证失败！" + res.message);
					}
				});
			})
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		beforeUpload(file){
			let limit = file.size / 1024 < 1024;
			if (!limit) {
			  this.$message.error('上传文件大小不能超过 1M');
			  return false;
			}
			return true;
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.warning {
    color: #ffaa00;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
